import React from 'react';
import { ReactComponent as EllipseSvg } from '../../graphics/ellipsemarker.svg';
import { ReactComponent as CrossSvg } from '../../graphics/crossmarker.svg';
import { Coordinate, VideoOverlayObject, PivotOption, Video } from '../VideoPlayer/VideoTypes';
import { projection } from '../Util/calib';

type Props = {
  coord: Coordinate,
  color: string,
  showAsX?: boolean,
  centerViewOnThis?: boolean,
  scale?: number,
  video?: Video,
  position?: Coordinate,
}

const markerProps = {
  stroke: "#000",
  strokeWidth: 1,
};

const PlayerMarker = (props: Props) => {
  const {
    coord,
    color,
    showAsX,
    centerViewOnThis,
    scale,
    video,
    position,
  } = props;
  
  const overlayObjects: VideoOverlayObject[] = [];

  if(centerViewOnThis) {
    const svgRay = <svg>
      <defs>
        <linearGradient id="linGrad" x1="0" x2="1" y1="0" y2="0">
          <stop offset="0%" stopColor={color} stopOpacity="0" />
          <stop offset="40%" stopColor={color} stopOpacity="0.3" />
          <stop offset="60%" stopColor={color} stopOpacity="0.3" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <rect width="100%" height="100%" fill="url(#linGrad)" />
    </svg>;

    const rayObject : VideoOverlayObject = {
      svg: svgRay,
      width: 85,
      height: 20000,
      center: coord,
      pivot: PivotOption.BottomCenter,
    };
    overlayObjects.push(rayObject);
  }

  //TRYOUT 3d OBJECT
  if(video && position) {
    const calib = JSON.parse(video?.calibration || '');

    const worldPositions: number[][] = [];

    /*
    let sides: number = 6;
    let radius: number = 0.5;
    const o: number = 0;//Date.now()%360;
    let z: number = 0;
    for(let a: number = o; a <= 360+o; a+=360/sides) {
      const heading: number = a * (Math.PI/180);
      const xIn: number = Math.cos(heading) * radius;
      const yIn: number = Math.sin(heading) * radius;
      worldPositions.push([position.x+xIn, position.y+yIn, z])
    }
    worldPositions.push([position.x, position.y, z])
    z=2;
    sides=4;
    radius=0.2;
    worldPositions.push([position.x, position.y, z])
    for(let a: number = o; a <= 360+o; a+=360/sides) {
      const heading: number = a * (Math.PI/180);
      const xIn: number = Math.cos(heading) * radius;
      const yIn: number = Math.sin(heading) * radius;
      worldPositions.push([position.x+xIn, position.y+yIn, z])
    }
    */
    worldPositions.push([position.x, position.y+0.5, 0])
    worldPositions.push([position.x, position.y+0.5, 2])
    
    worldPositions.push([position.x, position.y-0.5, 2])
    worldPositions.push([position.x, position.y-0.5, 0])

    const projectedData = projection(calib, worldPositions);

    // Create path of projected positions
    let path: string = "";
    for (let i: number = 0; i < projectedData.length; ++i) {
      const coord = projectedData[i];
      const isFirst: boolean = path.length === 0;
      path += (isFirst ? "M " : "L ") + coord[0].toString() + " " + coord[1].toString() + " ";
    }
    // Close the loop
    path+="z";

    const svg: JSX.Element = <svg>
      <path
        fill="#fff2"
        stroke={color}
        strokeWidth={1}
        d={path}
      />
      <circle
        cx={coord.x}
        cy={coord.y}
        r={2}
        fill={color}
      />
    </svg>

    const projectedObject : VideoOverlayObject = {
      svg: svg,
      width: 0,
      height: 0,
      center: coord,
      centerViewOnObject: centerViewOnThis,
      disableAutoScale: true,
    };
    overlayObjects.push(projectedObject);
  } else {
    const svgMarker = showAsX 
    ? <CrossSvg {...markerProps} fill={color} />
    : <EllipseSvg {...markerProps} fill={color} />;

    const markerObject : VideoOverlayObject = {
      svg: svgMarker,
      width: 32 * (scale || 1),
      height: 15 * (scale || 1),
      center: coord,
      centerViewOnObject: centerViewOnThis,
    };
    overlayObjects.push(markerObject);
  }

  return overlayObjects;
}

export default PlayerMarker;